module.exports = __webpack_public_path__ + "static/media/bdlogo.ff3e5167.png";